import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          customerIds: Yup.string()
                                                          .required('Required'),
                                          name: Yup.string()
                                                   .required('Required'),
                                          status: Yup.string()
                                                     .required('Required'),
                                          contactInfo: Yup.object()
                                                          .shape({
                                                                     email: Yup.string()
                                                                               .email('Invalid email'),
                                                                     phone: Yup.string(),
                                                                     website: Yup.string()
                                                                 }),
                                      });
